import * as React from 'react';
import { useSettingsQuery } from '../../lib/core/SettingsQuery';
import { Flex, Box, Container, Anchor, Link } from '../../components';
import Layout from '../Layout';
import FooterNav from './FooterNav';
import { i18nMessages } from '../../components/common-i18n';
import { FormattedMessage } from 'react-intl';
import {
  CurrentUser,
  settings_system,
  profilePageQuery,
  profilePageQuery_profilePage
} from '../../core-types';
import { NextRouter } from 'next/router';
import { useCurrentUser } from '../../lib/core/useCurrentUser';
import { useQuery } from '@apollo/client';
import { PROFILE_PAGE_QUERY } from './graphql';

type Props = {
  children: (renderProps: {
    profilePage: profilePageQuery_profilePage;
    system: settings_system;
    currentUser: CurrentUser;
    refetch: () => Promise<any>;
    privacyPolicyPage: string | null;
  }) => React.ReactNode;
  url: NextRouter;
  statusCode?: number;
};

const ProfileLayout = ({ children, url, statusCode }: Props) => {
  const settingsQueryProps = useSettingsQuery();
  const { currentUser, refetch } = useCurrentUser();
  const { data, loading } = useQuery<profilePageQuery>(PROFILE_PAGE_QUERY);
  return (
    <Layout
      statusCode={statusCode}
      title={data && data.profilePage && data.profilePage.title}
      url={url}
      requiresAuth
      loading={
        loading ||
        (settingsQueryProps.loading && settingsQueryProps.networkStatus !== 4)
      }
      contentProps={{
        // Override Content defaultProps
        py: 0,
        mx: 0,
        mb: 0
      }}
      render={() => {
        if (
          !data ||
          !data.profilePage ||
          !settingsQueryProps.data ||
          !settingsQueryProps.data.system ||
          !currentUser
        ) {
          return null;
        }
        return (
          <Flex column minHeight="80vh">
            <Container
              variant="narrow"
              data-testid="Profile"
              style={{ flex: '1 0 auto' }}
            >
              {url.pathname !== '/profile' && (
                <Flex column alignItems="center" mb={6}>
                  <Link route="profile" passHref>
                    <Anchor textDecoration="none" typoStyle="xxs">
                      / <FormattedMessage {...i18nMessages.profile} />
                    </Anchor>
                  </Link>
                </Flex>
              )}
              <Box mb={6}>
                {children({
                  profilePage: data.profilePage,
                  system: settingsQueryProps.data.system,
                  currentUser,
                  refetch,
                  privacyPolicyPage:
                    settingsQueryProps.data &&
                    settingsQueryProps.data.settings &&
                    settingsQueryProps.data.settings.privacyPageSlug &&
                    settingsQueryProps.data.settings.privacyPageSlug.current
                })}
              </Box>
            </Container>
            <FooterNav url={url} />
          </Flex>
        );
      }}
    />
  );
};

export default ProfileLayout;
